import { actionsTypes as types } from "../actions/userActions";

const INITIAL_STATE = {
  username: undefined,
  phase: "PENDING"
};
const userReducer = (state = INITIAL_STATE, action) => {
  var { user } = action;

  switch (action.type) {
    case types.RECEIVE_USER_START:
      return { ...state, phase: "PENDING" };

    case types.RECEIVE_USER_FINISHED:
      let uname = user && user.email ? user.email : undefined;
      let userid = user && user.id ? user.id : undefined;
      return { ...state, phase: "FINISHED", username: uname, id: userid };

    case types.RECEIVE_USER:
      console.log("Reducer: RECEIVE_USER", action);
      return {
        ...state,
        username: user.email,
        id: user.id,
        phase: "FINISHED"
      };
    case types.CLEAR_USER:
      console.log("Reducer: CLEAR_USER", action);
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default userReducer;
